import ReactDOM from 'react-dom';
import React from 'react';

import { EnvironmentThemeProvider } from '@codex-brightworld/themes';

import ProductImagesSection from './ProductImagesSection';

const initProductImagesSection = () => {
  const productImagesSectionEl = document.querySelector('div.product-images-section');

  if (productImagesSectionEl && window.galleryData) {
    const productImage = window.galleryData.productImage;
    const stickerImageURL = window.galleryData.stickerImageURL || undefined;
    const { displayCompareCheckbox, displayVideoLink, videoLinkLabel } = window.galleryData;
    const galleryImages = Array.isArray(window.galleryData.galleryImages) &&
      window.galleryData.galleryImages.length > 1 ? window.galleryData.galleryImages : undefined;
    const animatedMessageData = window.galleryData.animatedMessageData || undefined;

    ReactDOM.render(
      <EnvironmentThemeProvider>
        <ProductImagesSection
          stickerImageURL={stickerImageURL}
          productImage={productImage}
          displayCompareCheckbox={displayCompareCheckbox}
          displayVideoLink={displayVideoLink}
          videoLinkLabel={videoLinkLabel}
          galleryImages={galleryImages}
          animatedMessageData={animatedMessageData}
        />
      </EnvironmentThemeProvider>,
      productImagesSectionEl
    );
  }

};

export default initProductImagesSection;
